import { useTheme } from "../context/ThemeContext";
import { FaMoon, FaSun } from "react-icons/fa";
import { motion } from "framer-motion";

const DarkMode = () => {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <>
      <motion.div
        className="max-w-2xl mx-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.65, delay: 0.7, ease: "easeInOut" }}
      >
        <button
          onClick={toggleDarkMode}
          className="fixed max-md:absolute top-5 right-5 z-50 p-2 rounded-lg bg-opacity-20 backdrop-blur-sm transition-all duration-500 hover:scale-110"
        >
          {darkMode ? (
            <FaSun className="w-6 h-6 text-yellow-300" />
          ) : (
            <FaMoon className="w-6 h-6 text-slate-200" />
          )}
        </button>
      </motion.div>
    </>
  );
};

export default DarkMode;
